// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from 'app/common/ui/Tooltip';

import IconPC from '../icons/pc.svg';
import IconMobile from '../icons/mobile.svg';
import IconTerminal from '../icons/terminal.svg';

import styles from './CreatedWith.module.scss';;


type Props = {
  createdWith: 'computer' | 'mobile' | 'terminal',
}

const CreatedWith = ({ createdWith }: Props) => {
  const { t } = useTranslation('cafeteria');

  return (
    <React.Fragment>
      {createdWith === 'computer'
        && <Tooltip text={t('created_with_lk', 'Личный кабинет')}>
          <IconPC className={styles.icon} />
        </Tooltip>}
      {createdWith === 'mobile'
        && <Tooltip text={t('created_with_mobile', 'Мобильное приложение')}>
          <IconMobile className={styles.icon} />
        </Tooltip>}
      {createdWith === 'terminal'
        && <Tooltip text={t('created_with_terminal', 'Киоск самообслуживания')}>
          <IconTerminal className={styles.icon} />
        </Tooltip>}
    </React.Fragment>
  );
};

export default CreatedWith;
